import * as React from 'react'
import * as PropTypes from 'prop-types'
import styled from 'styled-components'

import Icon from '../../../../components/ui/Icon/Icon'
import AddCardPageForm from '../../containers/AddCardPageForm'
import AddCardSuccessModal from '../../../../components/home/AddCardSuccessModal/AddCardSuccessModal'
import * as CardApiService from '../../../../services/api/requests/Card'

import MoreHeaderParticles from '../../../../assets/img/more-header-particles.svg'

import { MAIN } from '../../../../services/data/profilePages.json'

const MainPage = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: 100%;
`

const Header = styled.div`
  position: relative;
  display: flex;
  flex: 0 0 auto;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  min-height: 87px;
  font-size: 0.7rem;
  background: var(--color-primary);

  &::before {
    content: ' ';
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    background: url('${MoreHeaderParticles}');
    background-repeat: no-repeat;
    background-position: right top;
  }
`

const ReturnIcon = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 2rem;
  height: 2rem;
  border-radius: 2rem;
  cursor: pointer;
  font-size: 0.92rem;
  margin-left: 20px !important;
  margin-right: 20px !important;
  color: var(--color-fg-light);
  background: rgba(255, 255, 255, 0.5);
  z-index: 1;

  & > svg {
    position: relative;
    color: #ffffff;
  }
`

const Title = styled.h1`
  flex: 1;
  padding: 20px 0;
  margin: 0;
  margin-right: 60px;
  color: #ffffff;
  font-size: 1.125rem;
  font-weight: var(--font-weight-boldest);
  text-transform: uppercase;
  text-align: center;
`

const Content = styled.div`
  padding: 2rem 1.1875rem;
  overflow: auto;
`

class AddCardPage extends React.Component {
  state = {
    showSuccessModal: false,
    cardList: [],
  }

  setReturnHome = async () => {
    await this.setState({
      showSuccessModal: false,
    })
  }

  loadCardList = async () => {
    const { accessToken } = this.props

    try {
      const { data } = await CardApiService.getAllCards(accessToken)

      this.setState({
        cardList: data,
        showSuccessModal: true,
      })
    } catch (err) {
      this.setState({
        showSuccessModal: true,
      })
    }
  }

  handleSuccess = () => {
    // this.loadCardList().then(() => {
    //   this.setState({
    //     showSuccessModal: true,
    //   })
    // })
    this.loadCardList()
  }

  handleSuccessModalClose = () => {
    const { setProfileModalPage } = this.props
    this.setState({
      showSuccessModal: false,
    })
    this.setReturnHome().then(() => setProfileModalPage(MAIN))
  }

  render() {
    const { setProfileModalPage } = this.props
    const { showSuccessModal, cardList } = this.state

    return (
      <MainPage>
        <Header>
          <ReturnIcon onClick={() => setProfileModalPage(MAIN)}>
            <Icon name="slide-left" />
          </ReturnIcon>

          <Title>Add Card</Title>
        </Header>
        <Content>
          <AddCardPageForm onSuccess={this.handleSuccess} />
        </Content>
        <AddCardSuccessModal
          show={showSuccessModal}
          onClose={this.handleSuccessModalClose}
          card={cardList && cardList.length > 0 ? cardList[0] : {}}
        />
      </MainPage>
    )
  }
}

AddCardPage.defaultProps = {
  setProfileModalPage: () => {},
}

AddCardPage.propTypes = {
  setProfileModalPage: PropTypes.func,
}

export default AddCardPage
